import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface PortalNotification {
    message: string;
    duration?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {

    constructor(private snackBar: MatSnackBar) { }

    showNotification({ message, duration = 4000 }: PortalNotification): void {
        this.snackBar.open(message, 'OK', { duration });
    }
}